<template>
  <div>
    <h3>Subscriptions</h3>

    <b-table
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      responsive="sm"
      striped
    >
      <template #cell(type)="{ item }">
        <i :class="productDetails[item.type].icon"></i>
        {{ item.type | capitalize }}
      </template>

      <template #cell(quantity)="{ item }">
        {{ item.quantity }}
        {{ item.quantity > 1 ? "Licenses" : "License" }}
      </template>

      <template #cell(pricing)="{ item }">
        {{ calcSubscriptionPrice(item) | currency }} /
        {{ item.interval }}
        <template v-if="item.discount"
          >(plus discount)</template
        >
      </template>

      <template #cell(details)="{ item }">
        <router-link
          :to="{
            name: 'Subscription',
            params: { subscriptionId: item.id }
          }"
          >More</router-link
        >
      </template>
    </b-table>
    <nav>
      <b-pagination
        v-if="items.length > perPage"
        v-model="currentPage"
        :total-rows="items.length"
        :per-page="perPage"
        align="center"
        prev-text="Prev"
        next-text="Next"
        hide-goto-end-buttons
      />
    </nav>
  </div>
</template>

<script>
import productDetails from "@/data/products";
import { calcTotalPrice } from "@/helpers/pricing";

export default {
  props: {
    items: {
      type: Array
    }
  },

  data: () => ({
    productDetails,
    fields: [
      { key: "type" },
      { key: "nickname", label: "Name" },
      { key: "pricing", label: "Pricing Plan" },
      { key: "quantity", class: "text-center" },
      { key: "details" }
    ],
    currentPage: 1,
    perPage: 50
  }),

  methods: {
    calcSubscriptionPrice(subscription) {
      return calcTotalPrice(subscription, subscription.quantity) / 100;
    }
  }
};
</script>

<style></style>
